<template>
	<div>
		<div class="confirmation-container">
			<h3>Confirm Filter Change</h3>
			<span data-test="confirmation-message">
				The previously selected contacts will be deselected. Are you
				sure you want to proceed?
			</span>
		</div>
		<OverviewModalFooter
			:success="success"
			:waiting="waiting"
			:isSaveModal="true"
			@handleClick="confirmFilterChange"
			@close="cancelFilterChange"
			primaryButtonName="Continue"
		/>
	</div>
</template>

<script>
import OverviewModalFooter from '@/views/client-connect-v2/modals/OverviewModalFooter.vue';

export default {
	name: 'ConfirmFilterChange',
	props: {
		success: Boolean,
		waiting: Boolean,
	},
	components: {
		OverviewModalFooter,
	},
	methods: {
		confirmFilterChange() {
			this.$emit('confirmFilterChange');
		},
		cancelFilterChange() {
			this.$emit('cancelFilterChange');
		},
	},
};
</script>

<style lang="scss" scoped>
.confirmation-container {
	display: flex;
	flex-direction: column;
	@include rem('margin', 20px auto 20px auto);
	width: 80%;
	justify-content: center;
	align-items: flex-start;
	h3 {
		font-weight: 600;
	}
}
</style>
